export const ELEMENT_ID = {
  accountDetails: 'accountDetails',
  documentBriefForm: 'documentBriefForm',
};

export const TEST_ID = {
  getScoreButton: 'GetScoreButton',
  lockedScorePopper: 'LockedScorePopper',
};
